import { clearAccessToken, removeSingleFeedCookie } from "../lib/utility";
import { router } from "../router";
import { userDetailStore } from "../stores/userDetailStore";
import { workspaceStore } from "../stores/workspaceStore";
import { addToast } from "../toasts";
import * as Sentry from "@sentry/browser";
import { httpService } from "./httpService";
import posthog from 'posthog-js';
import {isPosthogTrackEnabled} from "../utils/util.ts";

export const authService = {
  emailLogin(email: string, password: string) {
    const loginData = {
      username: email,
      password: password,
      grant_type: 'password',
      client_id: import.meta.env.VITE_OAUTH_CLIENT_ID,
      client_secret: import.meta.env.VITE_OAUTH_CLIENT_SECRET,
    };

    return httpService.postRequest<any, any>('oauth/token', loginData);
  },

  emailSignUp(email: string, password: string, token: string, referredBy: string|null) {
    const signupData = {
      _token: token,
      email: email,
      password: password,
      is_app_register: 1,
      referred_by: referredBy
    };

    return httpService.postRequest<any, any>('oauth/register', signupData);
  },

  socialLogin(access_token: string, referredBy: string|null) {
    const socailLoginData = {
      access_token: access_token,
      grant_type: "social",
      provider: "google",
      referred_by: referredBy,
      client_id: import.meta.env.VITE_OAUTH_CLIENT_ID,
      client_secret: import.meta.env.VITE_OAUTH_CLIENT_SECRET,
    };

    return httpService.postRequest<any, any>('oauth/token', socailLoginData);

  },

  forgotPassword(email: string) {
    return httpService.postRequest<any, any>('password/email', { email });
  },

  resetPasswordToken(email: string, token: string) {
    return httpService.getRequest<any>('password/reset/' + token + '?email=' + encodeURIComponent(email));
  },

  resetPassword(email: string, password: string, confirm_password: string, token: string) {
    const resetPasswordData = {
      email: email,
      password: password,
      confirm_password: confirm_password,
      token: token
    };
    return httpService.postRequest<any, any>('password/reset', resetPasswordData);
  },

  clearAuthSession() {
    //first clear all the stores
    workspaceStore.clearAllWorkspaces();
    userDetailStore.clearAllUserDetail();
    //clear the tokens
    clearAccessToken('fs3_access_token');

    // clear the selected user
    clearAccessToken('fs3_logged_in_user');

    // clear the workspace count
    clearAccessToken('fs3_workspace_count');

    // Clear the single feed cookie
    removeSingleFeedCookie();

    // Clear the user data for Sentry
    Sentry.setUser(null);

    // navigate to login page
    router.navigate("/login");
  },

  logout() {
    try {
      httpService.getRequest('oauth/logout');
      if(isPosthogTrackEnabled()) {
        posthog?.reset();
      }
    } catch (error: any) {
      addToast({ toastBody: error.message }, "default", "error");
    } finally {
      authService.clearAuthSession();
    }
  }
};
